<template>
    <div class="general-modal">
        <BaseModal :padding="isMobileOrTablet ? MODAL_PADDING_MOBILE : MODAL_PADDING_DESKTOP"
                   maxWidth="500px"
                   maxHeight="500px"
                   useContentFullHeight
                   useClickOutsideClose
                   @close="handleClose">
            <template #header/>
            <template #content>
                <div class="general-modal__content general-modal__content--justify-center">
                    <div class="general-modal__image">
                        <img :src="asset_cdn('assets/bybit-gift.svg')"
                             :alt="getTrans('quests-dashboard.reward', 'Reward')"
                             :title="getTrans('quests-dashboard.reward', 'Reward')"
                             width="170">
                    </div>
                    <div class="general-modal__title">
                        {{ bybitDealNotification?.data?.title || 'Claim your reward' }}
                    </div>
                    <div class="general-modal__subtitle">
                        {{ bybitDealNotification?.data?.subtitle || 'Claim 1,000 Bits and celebrate Bybit\'s 6th birthday with a shot at $2.2M prize pool!' }}
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="general-modal__actions">
                    <span class="general-modal__action general-modal__action--confirm">
                        <BaseButton v-focus
                                    @click="openNotificationUrl()">
                            <Translate translationKey="quests-dashboard.claimNow"
                                       fallback="CLAIM NOW"/>
                            🔥
                        </BaseButton>
                    </span>
                </div>
            </template>
        </BaseModal>
    </div>
</template>

<script setup lang="ts">
    import { ref, watch } from 'vue';
    import BaseModal from '@/js/components/BaseModal.vue';
    import { ModalEnum, useModalStore } from '@/js/store/quests/game/modules/ModalStore';
    import { useModalActive } from '@/js/composables/useModalActive';
    import { useDeviceSize } from '@/js/composables/useDeviceSize';
    import BaseButton from '@/js/components/BaseButton.vue';
    import { asset_cdn } from '@/js/helpers/helpers';
    import { getTrans } from '@/js/helpers/getTrans';
    import { Notification } from '@/js/quests/dashboard/types/types';
    import { NotificationModalTypeEnum } from '@/js/quests/dashboard/types/enums';
    import { useUserStore } from '@/js/store/quests/dashboard/UserStore';
    import { MODAL_PADDING_DESKTOP, MODAL_PADDING_MOBILE } from '@/js/quests/global/constants/modal';

    const modalStore = useModalStore();
    const userStore = useUserStore();
    const { isMobileOrTablet } = useDeviceSize();

    const notifications = ref<Notification[]>([]);
    const bybitDealNotification = ref();

    const openNotificationUrl = () => {
        const DEFAULT_BYBIT_DEAL_URL = '/extra/bybit-deal';

        window.location.href = bybitDealNotification.value?.data?.url ?? DEFAULT_BYBIT_DEAL_URL;
    };

    const handleClose = () => {
        modalStore.toggleModal(ModalEnum.BYBIT_DEAL_NOTIFICATION, false);
    };

    useModalActive();

    watch(
        () => modalStore.modals[ModalEnum.BYBIT_DEAL_NOTIFICATION],
        (newValue) => {
            if (newValue) {
                notifications.value = userStore?.notifications ?? [];
                const filteredNotifications = notifications.value.filter(
                    (notification) => notification.type === NotificationModalTypeEnum.BybitDeal,
                );
                bybitDealNotification.value = filteredNotifications.length > 0 ? filteredNotifications[0] : null;
            }
        },
        { immediate: true },
    );
</script>

<style scoped lang="scss">
@use "@/js/quests/dashboard/sass/mixins/_modal" as modalMixins;

.general-modal {
    @include modalMixins.modal;

    &__image {
        img {
            width: 170px;
            margin-bottom: 16px;
        }
    }
}
</style>
